
//********************************************************************************************** */
// Product Card Swatch Slider

let initialize_swatch_slider = () => {
  let biggestSwatchSliderHeight = '0'
  let biggestTitleHeight = '0'
  $('.swatch-slider').each((index, item) => {
    let slider = $(item)
    let owl = slider.find('.owl-carousel')
    owl.owlCarousel({
      mouseDrag: false,
      pullDrag: false,
      touchDrag: false,
      dots: false,
      margin: 7,
      // items: 5,
      responsive: {
        0: {
          items: 5
        },
        768: {
          items: 6
        }
      }
    }
    )

    // Go to the next item
    slider.find('.owl-nav-right').click(function () {
      owl.trigger('next.owl.carousel', [300]);
      owl.trigger('next.owl.carousel', [300]);
      owl.trigger('next.owl.carousel', [300]);
      owl.trigger('next.owl.carousel', [300]);
      owl.trigger('next.owl.carousel', [300]);
    })
    // Go to the previous item
    slider.find('.owl-nav-left').click(function () {
      // With optional speed parameter
      // Parameters has to be in square bracket '[]'
      owl.trigger('prev.owl.carousel', [300]);
      owl.trigger('prev.owl.carousel', [300]);
      owl.trigger('prev.owl.carousel', [300]);
      owl.trigger('prev.owl.carousel', [300]);
      owl.trigger('prev.owl.carousel', [300]);
    })

    // let firstOwlItem = $(item).find('.owl-item').first()
    // firstOwlItem.addClass('swatch_selected')
    let height = $(item).height()
    if (height > biggestSwatchSliderHeight) {
      biggestSwatchSliderHeight = height
    }
  })
  $('.swatch-slider').each((index, item) => {
    $(item).css('height', biggestSwatchSliderHeight)
  })
  $('.product-title').each((index, item) => {
    let height = $(item).height()
    if (height > biggestTitleHeight) {
      biggestTitleHeight = height
    }
  })
  $('.product-title').each((index, item) => {
    $(item).css('height', biggestTitleHeight)
  })


  $('.swatch-slider').find('.owl-item').click(function () {
    let self = $(this)
    let title = self.find('.swatch-slider-cell').attr('data-title')
    let subtitle = self.find('.swatch-slider-cell').attr('data-subtitle')
    // let product_card = self.closest('.product-card').find('.product-title').text()
    // console.log(title)
    self.closest('.product-card').find('.product-title').contents()[0].replaceWith(title)
    self.closest('.product-card').find('.product-subtitle').text(subtitle)
    self.closest('.product-card').find('.product_nav_button').addClass('hidden')
    self.closest('.product-card').find('.add_to_cart_button').removeClass('hidden').removeAttr('disabled')
    // console.log(element)
    // $('h1.product-title').text(title)

    self.addClass('swatch_selected').siblings().removeClass('swatch_selected')
    let variant_id = self.find('.swatch-slider-cell').attr('data-id')
    self.closest('.product-card').find('input[name="id"]').attr('value', variant_id)

    let image_url_1 = self.find('.swatch-slider-cell').attr('data-image1')
    let image_url_2 = self.find('.swatch-slider-cell').attr('data-image2')

    self.closest('.product-card').find('.product-card__figure').find('.product-card__image--primary').fadeOut(50)
    self.closest('.product-card').find('.product-card__figure').find('.product-card__image--secondary').fadeOut(50, () => {
      self.closest('.product-card').find('.product-card__figure').find('.product-card__image--primary').attr('src', image_url_1).attr('srcset', image_url_1)
      self.closest('.product-card').find('.product-card__figure').find('.product-card__image--secondary').attr('src', image_url_2).attr('srcset', image_url_2)
      self.closest('.product-card').find('.product-card__figure').find('.product-card__image--primary').fadeIn(130)
      self.closest('.product-card').find('.product-card__figure').find('.product-card__image--secondary').fadeIn(130)
    })
  })
}

$(window).ready(function () {
  initialize_swatch_slider()
});
$(document).on('recommendationsLoaded', function () {
  // Reinitialize the Owl Carousel for the newly loaded content
  initialize_swatch_slider()
});
$(document).on('predictiveSearchResultsLoaded', function () {
  // Reinitialize the Owl Carousel for the newly loaded content
  initialize_swatch_slider()
});

//********************************************************************************************** */
// Swatch Gallery


// $(document).ready(function () {
//   $(document).on('click', '.product .color-swatch', function () {
//     let self = $(this)
//     let title = self.attr('data-title')
//     let variant_id = self.attr('data-variant-id')
//     let subtitle = self.attr('data-subtitle')
//     if($(this).hasClass('is-disabled')) {
//       $('.buy-button-container').addClass('force-hidden')
//     } else {
//       $('.buy-button-container').removeClass('force-hidden')
//     }
//     $('h1.product-title').text(title)

//     $('.product-gallery').fadeOut(250, () => {
//       // $('.product-gallery').addClass('hidden')
//       // $(`.product-gallery.variant-id-${variant_id}`).removeClass('hidden')
//     })
//     $(`.product-gallery.variant-id-${variant_id}`).fadeIn(130)

//     $(`.complementary-products__product-list .recommended-variant`).addClass('hidden')
//     $(`.complementary-products__product-list .variant-id-${variant_id}`).removeClass('hidden')

//     $('.ingredients').addClass('hidden')
//     $(`.ingredients-${variant_id}`).removeClass('hidden')

//     $('.blurb').addClass('hidden')
//     $(`.blurb-${variant_id}`).removeClass('hidden')
//     if(subtitle) {
//       $('.product-subtitle').text(subtitle)
//     }
//     let title_segments = title.split(' | ')
//     $('.variant-picker__option-info span').text(title_segments[title_segments.length - 1])
//   })
// })
//********************************************************************************************** */
// Swatch Gallery / Shade Grid Gallery Sync

$(document).ready(function () {
  function setGalleryDisplay($elements, displayValue) {
    $elements.each(function () {
      this.style.setProperty('display', displayValue, 'important')
      this.style.setProperty('opacity', '1', 'important')
      this.style.setProperty('visibility', 'visible', 'important')
    })
  }

  function showVariantGallery(variantId) {
    if (!variantId) {
      console.warn('Variant ID missing for gallery update')
      return
    }

    let $allGalleries = $('product-gallery.product-gallery[class*="variant-id-"]')
    let $selectedGallery = $(`product-gallery.product-gallery.variant-id-${variantId}`)

    console.log('Gallery update variant:', variantId)
    console.log('All variant galleries:', $allGalleries.length)
    console.log('Selected gallery found:', $selectedGallery.length)

    if (!$allGalleries.length) {
      console.warn('No variant galleries found on page')
      return
    }

    if (!$selectedGallery.length) {
      console.warn('No gallery found for variant:', variantId)
      return
    }

    // Hide all variant galleries
    $allGalleries
      .stop(true, true)
      .addClass('hidden')
      .attr('aria-hidden', 'true')

    setGalleryDisplay($allGalleries, 'none')

    // Show selected variant gallery
    $selectedGallery
      .stop(true, true)
      .removeClass('hidden')
      .removeAttr('hidden')
      .attr('aria-hidden', 'false')

    setGalleryDisplay($selectedGallery, 'inline-block')

    // Reset selected gallery carousel to first image
    let carousel = $selectedGallery.find('scroll-carousel').get(0)

    if (carousel) {
      carousel.scrollLeft = 0

      if (typeof carousel.scrollTo === 'function') {
        carousel.scrollTo({
          left: 0,
          top: 0,
          behavior: 'auto'
        })
      }
    }

    // Reset thumbnails
    $selectedGallery.find('.product-gallery__thumbnail').attr('aria-current', 'false')
    $selectedGallery.find('.product-gallery__thumbnail').first().attr('aria-current', 'true')
  }

  function getVariantIdFromElement($element) {
    return (
      $element.attr('data-variant-id') ||
      $element.attr('data-id') ||
      $element.find('[data-variant-id]').attr('data-variant-id') ||
      $('form[action*="/cart/add"] input[name="id"]').val()
    )
  }

  // Initial load
  setTimeout(function () {
    let initialVariantId =
      $('form[action*="/cart/add"] input[name="id"]').val() ||
      $('[data-shade-grid-swatch].is-selected').attr('data-variant-id') ||
      $('.product .color-swatch[aria-checked="true"], .product .color-swatch.is-selected, .product .color-swatch.active').first().attr('data-variant-id')

    showVariantGallery(initialVariantId)
  }, 300)

  // New draft shade-grid swatch click
  $(document).on('click', '[data-shade-grid-swatch], .shade-grid__swatch', function () {
    let $self = $(this)
    let variantId = getVariantIdFromElement($self)

    setTimeout(function () {
      showVariantGallery(variantId)
    }, 80)
  })

  // Native variant event from shade-grid
  $(document).on('variant:change', 'form[action*="/cart/add"]', function (event) {
    let variantId = event.originalEvent?.detail?.variant?.id

    if (!variantId) {
      variantId = $('form[action*="/cart/add"] input[name="id"]').val()
    }

    showVariantGallery(variantId)
  })

  // Old/live color swatch support
  $(document).on('click', '.product .color-swatch', function () {
    let $self = $(this)
    let title = $self.attr('data-title')
    let variantId = getVariantIdFromElement($self)
    let subtitle = $self.attr('data-subtitle')

    setTimeout(function () {
      if ($self.hasClass('is-disabled')) {
        $('.buy-button-container').addClass('force-hidden')
      } else {
        $('.buy-button-container').removeClass('force-hidden')
      }

      if (title) {
        $('h1.product-title').text(title)
      }

      showVariantGallery(variantId)

      $('.complementary-products__product-list .recommended-variant').addClass('hidden')
      $(`.complementary-products__product-list .variant-id-${variantId}`).removeClass('hidden')

      $('.ingredients').addClass('hidden')
      $(`.ingredients-${variantId}`).removeClass('hidden')

      $('.blurb').addClass('hidden')
      $(`.blurb-${variantId}`).removeClass('hidden')

      if (subtitle) {
        $('.product-subtitle').text(subtitle)
      }

      if (title) {
        let title_segments = title.split(' | ')
        $('.variant-picker__option-info span').text(title_segments[title_segments.length - 1])
      }
    }, 80)
  })
})

//********************************************************************************************** */
// Variant Categories

$(document).ready(function () {
  $(document).on('click', '.category-wrapper .variant-category', function () {
    let self = $(this)
    // let category = self.text().toLowerCase()
    self.closest('.category-wrapper').find('.variant-category').removeClass('active')
    self.addClass('active')
    let categoryClasses = ''


    $('.category-wrapper').each(function() {
        var activeText = $(this).find('.active').text(); // Find the child with .active class and get its text
        if (activeText && activeText !== 'All') { // Only add if there's text content
          categoryClasses += `.category_${activeText.toLowerCase()}`;
        }
    });

    if(categoryClasses) {
      $('.product .color-swatch').fadeOut(250, () => {
        setTimeout(function() {
          $(`.product .color-swatch${categoryClasses}`).fadeIn(250)
        }, 200);
      })
    } else {
      // $('.product .color-swatch').fadeOut(250, () => {
      //   setTimeout(function() {
      $(`.product .color-swatch`).fadeIn(250);
      //   }, 200);
      // })
    }
  })
})
function applyCategoryselection () {

}
//**********************************************************************************************
// Findation Button Hacks


$(document).ready(function () {
  $(document).on('click', '.findation-link', function () {
    window.Findation.openWidget()
  });
});


$(document).ready(function () {
  $(document).on('click', '.virtual-try-on-button', function () {
    neo({
      client_id: 80,
      configuration_id: 32766
    });
  })
})

//**********************************************************************************************
// Misc Hacks

$(document).ready(function () {
	function updatePromoImageHeight() {
		if ($(window).width() > 768) { // Apply only on desktop (width > 768px)
			$('.featured-collections-carousel__item.promo_image_true').each(function () {
				let productCard = $(this).find('.product-card').first(); // Find first product card inside
				if (productCard.length) {
					let cardHeight = productCard.outerHeight(); // Get its height
					$(this).height(cardHeight); // Set the parent height
				}
			});
		} else {
			// Reset height on mobile to avoid issues
			$('.featured-collections-carousel__item.promo_image_true').css('height', ''); 
		}
	}

	// Run on page load
	updatePromoImageHeight();

	// Run again if window resizes (for responsiveness)
	$(window).resize(updatePromoImageHeight);
});


$(document).on('click', '.swatch-slider .owl-item', function () {
  let self = $(this)
  let cell = self.find('.swatch-slider-cell')

  if (!cell.length) return

  let roundelData = cell.attr('data-roundel')

  let roundelContainer = self
    .closest('.product-card')
    .find('.product-card__roundel_card')

  if (!roundelContainer.length) return

  roundelContainer.empty()

  if (!roundelData || roundelData.trim() === '') {
    roundelContainer.hide()
    return
  }

  roundelContainer.show()

  let badges = roundelData.split('||')

  badges.forEach(function (badge) {
    badge = badge.trim()
    if (badge !== '') {
      roundelContainer.append(
        `<span class="badge badge--custom badge--roundel-text badge--${badge
          .toLowerCase()
          .replace(/\s+/g, '-')}">${badge}</span>`
      )
    }
  })
})

